import React from "react";
import PropTypes from "prop-types";
import "./index.scss";

const AmountCell = ({ value }) => {
  const formattedAmount = (value / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2,
  });
  return (
    <div data-testid="amount-cell" className="amount-cell">
      <div className="details">
        <span className="name">{`$ ${formattedAmount}`}</span>
      </div>
    </div>
  );
};

AmountCell.propTypes = {
  value: PropTypes.string.isRequired,
};

export default AmountCell;
